import { LandingLayout } from 'layouts';
import { useLocation } from 'react-router';
import { ContentLeft, Footer, Header, type HeaderItem, PasswordlessLogin } from 'features/onboarding';
import { useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type PasswordlessLocationState = OnboardingLocationState;

const PagePasswordlessLogin = () => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const state: PasswordlessLocationState | undefined = location.state;
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin, onNavigateToSignUp, onReplaceCheckMagicLink } =
    useOnboardingNavigation<PasswordlessLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Sign up',
      async onClick() {
        await onNavigateToSignUp();
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={
        <PasswordlessLogin<PasswordlessLocationState>
          onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
          onReplaceCheckMagicLink={onReplaceCheckMagicLink}
          state={state}
        />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PagePasswordlessLogin;
